import {BlockType} from './block';

// Block Types
import {fileUpload} from './FileUpload/file-upload';
import {chemicalEquation} from './ChemicalEquation/chemical-equation';
import {multiSelect} from './MultiSelect/multi-select';
import {multipleChoice} from './MultipleChoice/multiple-choice';
import {textBlock} from './Text/text-block';
import {link} from './Link/link';
import {singleCalculation} from './Calculation/single-calculation';
import {rankOrder} from './RankOrder/rank-order';
import {textarea} from './Textarea/textarea';
import {image} from './Image/image';
import {richTextComponentType} from './RichText/rich-text';
import {aiGrader} from './AiGrader/ai-grader';

const blockTypesById: Record<string, BlockType<any, any>> = {
  AiGrader: aiGrader,
  Calculation: singleCalculation,
  SingleCalculation: singleCalculation,
  FileUpload: fileUpload,
  MultipleChoice: multipleChoice,
  MultiSelect: multiSelect,
  Textarea: textarea,
  Image: image,
  Link: link,
  Text: textBlock,
  TextBlock: textBlock,
  RankOrder: rankOrder,
  RichText: richTextComponentType,
  ChemicalEquation: chemicalEquation,
};

type BlockTypeLibrary = {
  blockTypes: BlockType<any, any>[];
  find(type: string): BlockType<any, any> | null;
};

export function useBlockTypeLibrary(): BlockTypeLibrary {
  let blockTypes: Array<BlockType<any, any>> = [
    // Display Only
    richTextComponentType,
    image,
    // Input Only
    textarea,
    // Input + Grading
    multipleChoice,
    multiSelect,
    singleCalculation,
    fileUpload,
    rankOrder,
    chemicalEquation,
    aiGrader,
  ];

  return {
    blockTypes,
    find(type: string): BlockType<any, any> | null {
      return blockTypesById[type] || null;
    },
  };
}
